var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitImpersonationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7893_22792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.45312 5.45931C5.58142 5.87003 5.80695 6.24372 6.11058 6.54862C6.4142 6.85352 6.78694 7.08063 7.19712 7.21064M9.53512 6.84731C9.85329 6.62285 10.1184 6.33144 10.3119 5.99355C10.5054 5.65567 10.6226 5.27951 10.6552 4.89151C10.6878 4.50351 10.635 4.11307 10.5006 3.74764C10.3661 3.38222 10.1533 3.05066 9.87706 2.77628C9.6008 2.50189 9.2678 2.29133 8.90146 2.1594C8.53513 2.02746 8.14434 1.97735 7.75657 2.01259C7.3688 2.04782 6.99345 2.16755 6.65689 2.36335C6.32033 2.55916 6.03074 2.82629 5.80846 3.14597",
    stroke: "#B3B8C1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 14V12.6667C4 11.9594 4.28095 11.2811 4.78105 10.781C5.28115 10.281 5.95942 10 6.66667 10H9.33333C9.608 10 9.87333 10.0413 10.122 10.1187M11.8773 11.864C11.9573 12.1173 12 12.3873 12 12.6667V14",
    stroke: "#B3B8C1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2L14 14",
    stroke: "#B3B8C1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7893_22792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitImpersonationIcon);
export default __webpack_public_path__ + "static/media/ExitImpersonationIcon.bb90596d350c41d17ff450c3af8e7d13.svg";
export { ForwardRef as ReactComponent };